import React from 'react';

export function DownArrow({ visible, onClick }) {
  if (!visible) return null;
  return (
    <button className="gallery-scroll-arrow down" onClick={onClick} aria-label="Scroll down">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="18" fill="#0D5EAF" fillOpacity="0.88"/>
        <path d="M11 15l7 7 7-7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
}

export function UpArrow({ visible, onClick }) {
  if (!visible) return null;
  return (
    <button className="gallery-scroll-arrow up" onClick={onClick} aria-label="Scroll up">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="18" fill="#0D5EAF" fillOpacity="0.88"/>
        <path d="M25 21l-7-7-7 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
}
